import {Block, Variable, NumberBlock, StringBlock, Callback, Sprite} from "./index";
import {STATE, GRAMMAR} from "../Type";

export class GlobalAction extends Block {
  get type() {
    return "GlobalAction";
  }

  get category() {
    return "GlobalAction";
  }

  getGrammarFor() {
    return GRAMMAR.VERB;
  }

  getDefaultChildren() {
    switch (this.data) {
      case "wait":
      case "sendSignal":
      case "changePlayerSpeed":
        return [new Block({state: STATE.INSTANCE, parent: this})];
      case "onSignal":
        return [new Block({state: STATE.INSTANCE, parent: this}), new Callback({state: STATE.INSTANCE, parent: this})];
      default:
        return [];
    }
  }

  static getPrototypeBlocks() {
    const prototypeBlocks = [];
    const actionNames = GlobalAction.getActionNames();
    for (let i = 0; i < actionNames.length; i++) {
      const actionName = actionNames[i];
      prototypeBlocks.push(new GlobalAction({data: actionName, state: STATE.PROTOTYPE}));
    }
    return prototypeBlocks;
  }

  static getActionNames() {
    return ["wait", "onSignal", "sendSignal", "changePlayerSpeed", "startTimer", "pauseTimer", "resumeTimer", "resetTimer"];
  }

  getAvailableChildTypesAt(index) {
    switch (this.data) {
      case "wait":
      case "changePlayerSpeed":
        return [NumberBlock, Variable];
      case "sendSignal":
        return [StringBlock];
      case "onSignal":
        return [[StringBlock], [Callback]][index] || [];
      default:
        return [];
    }
  }

  getFinalChildTypesAt(index) {
    switch (this.data) {
      case "wait":
      case "changePlayerSpeed":
        return [NumberBlock, Variable];
      case "onSignal":
      case "sendSignal":
        return [Variable, Sprite, Screen, Text];
      default:
        return this.getAvailableChildTypesAt(index);
    }
  }

  toJavascript() {
    switch (this.data) {
      case "wait":
        return this.toJavascriptForAsync();
      case "onSignal":
      case "sendSignal":
      case "changePlayerSpeed":
        return this.toJavascriptForDefault();
      default:
        return this.toJavascriptForDefault();
    }
  }

  getArgsToJavascript() {
    let args = "";
    for (let i in this.children) {
      const child = this.children[i];
      if (i !== "0") {
        args += ", ";
      }
      args += child.toJavascript();
    }
    return args;
  }

  toJavascriptForAsync() {
    const apiName = this.data;
    const args = this.getArgsToJavascript();
    return `await this.${apiName}(${args})`;
  }
  toJavascriptForDefault() {
    const apiName = this.data;
    const args = this.getArgsToJavascript();
    return `this.${apiName}(${args})`;
  }
}
